import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import env from '../../../../networkRequests/apiClient/env.config'
import status from '../../../../shared/functions/Status/status.dictionaries'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  GetPurchaseReadyItemsErrorResponse,
  GetPurchaseReadyItemsRequest,
  GetPurchaseReadyItemsSuccessResponse
} from './getPurchaseReadyItems.types'

export const getPurchaseReadyItemsApi = async (
  request: GetPurchaseReadyItemsRequest
): Promise<GetPurchaseReadyItemsSuccessResponse> => {
  const response = await configureRequest({
    url: urls.admin.getPurchaseReadyItems,
    method: 'GET',
    params: {
      page: request.page ?? 1,
      size: request.size ?? env.DEFAULT_PAGE_SIZE,
      status: request.status || status.itemRequestStatus.readyForPurchase,
      ...(request.searchQuery ? { searchQuery: request.searchQuery } : {})
    },
    headers: {
      'X-User-Role': UserRole.admin
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetPurchaseReadyItemsSuccessResponse
  } else {
    throw response as GetPurchaseReadyItemsErrorResponse
  }
}

export default getPurchaseReadyItemsApi
